import UserFunctionsGetter from '../Controller/getSQLUserFunctions.js';
import DataServiceSQL from "../DataService/DataServiceSQL.js";

const stop_Shares = async (FK_User, local_id_patient) => {
    //console.log("Get Profile Information");
    let ret = false
    return await DataServiceSQL.deleteLinkage_fhir(undefined, FK_User, local_id_patient)
      .then(response => {
          if (response.status === 204) {
            ret = true
          }
          return ret
      })
      .catch(e => {
        console.log(e);
        return ret
      });
};

//Const to import functions in other files
const SharesGetter = {
  stop_Shares
};

export default SharesGetter;